export default "__VITE_ASSET__CTMIUN6r__"